module.exports = __webpack_public_path__ + "img/4.03991b06.jpg";